
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { iconLibrary } from '../utilities/iconsLibrary.utility';

@Options({
	name: 'Icon',
	components: {},
})
export default class Icon extends Vue {
	@Prop() name!: string;
	@Prop({ default: 24 }) size!: number; // dimensions
	@Prop({ default: null }) width!: number | null;

	@Prop({ default: '#000' }) color!: string;

	get iconSvg() {
		return iconLibrary.getIcon(this.name.toLowerCase(), this.size, this.size, this.width ?? undefined);
	}
}
